import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { CreateTaskInput, CreateTaskMutation } from '@/gql/graphql';

const CREATE_TASK_MUTATION = graphql(`
  mutation CreateTask($input: CreateTaskInput!) {
    createTask(input: $input) {
      ... on IEntity {
        id
      }
    }
  }
`);

const useCreateTask = (
  options?: UseMutationOptions<CreateTaskMutation, unknown, CreateTaskInput>
) => {
  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(CREATE_TASK_MUTATION, { input });
    },
    ...options,
  });
};

export default useCreateTask;
